import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Software from './views/software.vue'
import Hardware from './views/hardware.vue'
import Hosting from './views/hosting.vue'
import Consulting from './views/consulting.vue'
import Team from './views/team.vue'
import Downloads from './views/downloads.vue'
import Plog from './views/plog.vue'
import Admin from './views/admin.vue'

Vue.use(Router)

var routes = [
  { path: '/', name: 'home', component: Home },
  { path: '/software', name: 'software', component: Software },
  { path: '/hosting', name: 'hosting', component: Hosting },
  { path: '/hardware', name: 'hardware', component: Hardware },
  { path: '/consulting', name: 'consulting', component: Consulting },
  { path: '/team', name: 'team', component: Team },
  { path: '/downloads', name: 'downloads', component: Downloads },
  { path: '/plog', name: 'plog', component: Plog },
  {
    path: '/admin',
    name: 'admin',
    component: Admin,
    beforeEnter: (to, from, next) => {
      //  console.log('router ' + from.fullPath + ' => ' + to.fullPath)
      //  test authorization
      next(false)
    }
  },
  // otherwise redirect to home
  { path: '*', redirect: '/' }
]

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  }
})

//  router.beforeEach(to, from, next) => {
//    console.log('router ' + to + ', ' + from + ', ' + next + ', ')
//  })
